import { defineStore } from "pinia";

export function generateVariables() {
  return {
    font: {
      bodyFontFamily: getComputedStyle(document.body)
        .getPropertyValue("--bs-body-font-family")
        .trim(),
      bodyFontSize: getComputedStyle(document.body)
        .getPropertyValue("--bs-body-font-size")
        .trim(),
      bodyFontWeight: getComputedStyle(document.body)
        .getPropertyValue("--bs-body-font-weight")
        .trim(),
    },
    color: {
      componentColor: getComputedStyle(document.body)
        .getPropertyValue("--bs-component-color")
        .trim(),
      componentBg: getComputedStyle(document.body)
        .getPropertyValue("--bs-component-bg")
        .trim(),
      theme: getComputedStyle(document.body)
        .getPropertyValue("--bs-app-theme")
        .trim(),
      blue: getComputedStyle(document.body)
        .getPropertyValue("--bs-blue")
        .trim(),
      teal: getComputedStyle(document.body)
        .getPropertyValue("--bs-teal")
        .trim(),
      green: getComputedStyle(document.body)
        .getPropertyValue("--bs-green")
        .trim(),
      lime: getComputedStyle(document.body)
        .getPropertyValue("--bs-lime")
        .trim(),
      orange: getComputedStyle(document.body)
        .getPropertyValue("--bs-orange")
        .trim(),
      red: getComputedStyle(document.body).getPropertyValue("--bs-red").trim(),
      cyan: getComputedStyle(document.body)
        .getPropertyValue("--bs-cyan")
        .trim(),
      purple: getComputedStyle(document.body)
        .getPropertyValue("--bs-purple")
        .trim(),
      yellow: getComputedStyle(document.body)
        .getPropertyValue("--bs-yellow")
        .trim(),
      indigo: getComputedStyle(document.body)
        .getPropertyValue("--bs-indigo")
        .trim(),
      pink: getComputedStyle(document.body)
        .getPropertyValue("--bs-pink")
        .trim(),
      black: getComputedStyle(document.body)
        .getPropertyValue("--bs-black")
        .trim(),
      white: getComputedStyle(document.body)
        .getPropertyValue("--bs-white")
        .trim(),
      gray: getComputedStyle(document.body)
        .getPropertyValue("--bs-gray")
        .trim(),
      dark: getComputedStyle(document.body)
        .getPropertyValue("--bs-dark")
        .trim(),
      gray100: getComputedStyle(document.body)
        .getPropertyValue("--bs-gray-100")
        .trim(),
      gray200: getComputedStyle(document.body)
        .getPropertyValue("--bs-gray-200")
        .trim(),
      gray300: getComputedStyle(document.body)
        .getPropertyValue("--bs-gray-300")
        .trim(),
      gray400: getComputedStyle(document.body)
        .getPropertyValue("--bs-gray-400")
        .trim(),
      gray500: getComputedStyle(document.body)
        .getPropertyValue("--bs-gray-500")
        .trim(),
      gray600: getComputedStyle(document.body)
        .getPropertyValue("--bs-gray-600")
        .trim(),
      gray700: getComputedStyle(document.body)
        .getPropertyValue("--bs-gray-700")
        .trim(),
      gray800: getComputedStyle(document.body)
        .getPropertyValue("--bs-gray-800")
        .trim(),
      gray900: getComputedStyle(document.body)
        .getPropertyValue("--bs-gray-900")
        .trim(),
    },
  };
}

export const useAppVariableStore = defineStore("appVariable", {
  state: () => generateVariables(),
});
